import { render, staticRenderFns } from "./WeChatListUnProcessed.vue?vue&type=template&id=5ea56510&scoped=true"
import script from "./WeChatListUnProcessed.vue?vue&type=script&lang=js"
export * from "./WeChatListUnProcessed.vue?vue&type=script&lang=js"
import style0 from "./WeChatListUnProcessed.vue?vue&type=style&index=0&id=5ea56510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea56510",
  null
  
)

export default component.exports